import type { ComponentTheme } from '../types/component-theme';

import { softPanelSurfaceStyles } from '../shared-styles';

export default {
    slots: {
        root: `${softPanelSurfaceStyles} shadow-(--panel-shadow-soft-inset)`
    }
} satisfies ComponentTheme;
